import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  NgZone,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { GoogleMapsService } from '../../services/google.maps.service';

@Component({
  selector: 'ig-city-selector',
  templateUrl: './city.selector.component.html',
  styleUrls: ['./city.selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CitySelectorComponent),
      multi: true,
    },
  ],
})
export class CitySelectorComponent implements AfterViewInit, ControlValueAccessor {
  public addressValue = '';
  @Input() public disabled = false;
  @Input() public label: string;
  @Input() public isRequired: true;
  @Input() public type = 'float';
  @Input() public searchType: 'cities' | 'geocode' = 'cities';
  @Input() public placeholder = '';
  @Input() public innerLabel = false;
  @ViewChild('inputElement') public inputElement: any;
  @Output() onAddressClear: EventEmitter<any> = new EventEmitter<any>();
  public locationFormGroup: FormGroup;

  private _value: {
    lat: number;
    lng: number;
    address: string;
    city: string;
    state: string;
    country: string;
    placeId: string;
  };
  private _notifyChange: any;

  constructor(
    private googleMapService: GoogleMapsService,
    private formBuilder: FormBuilder,
    private zone: NgZone
  ) {
    this.locationFormGroup = this.formBuilder.group({
      'address': [null, [Validators.required]],
    });
  }

  public get value() {
    return this._value;
  }

  public set value(newValue: any) {
    this._value = newValue;
    this._notifyChange(this._value);
  }

  public registerOnChange(fn: any): void {
    this._notifyChange = fn;
  }

  public registerOnTouched(fn: any): void {}

  public writeValue(obj: {
    lat: number;
    lng: number;
    address: string;
    city: string;
    state: string;
    country: string;
    placeId: string;
  }): void {
    this._value = obj;
    this.addressValue = !!this._value ? this._value.address : null;
  }

  public ngAfterViewInit() {
    const options: any = {
      componentRestrictions: { country: ['us', 'pt', 'uk', 'ca'] },
      // componentRestrictions: {country: "us"}
    };
    if (this.searchType === 'geocode') {
      options.types = ['geocode'];
    } else {
      options.types = ['(cities)'];
    }

    this.googleMapService.getGoogle().then((googleObject: any) => {
      let ele =
        this.type === 'float'
          ? this.inputElement.nativeElement
          : this.inputElement.input.nativeElement;
      let autoComplete = new googleObject.maps.places.Autocomplete(ele, options);
      autoComplete.addListener('place_changed', () => {
        this.zone.run(() => {
          let place = autoComplete.getPlace();

          if (place.geometry) {
            let state = '',
              country = '';
            if (place.address_components) {
              const stateComponent = place.address_components.find((x) =>
                x.types.includes('administrative_area_level_1')
              );
              if (stateComponent) {
                state = stateComponent.short_name || stateComponent.shortText;
              }
              const countryComponent = place.address_components.find((x) =>
                x.types.includes('country')
              );
              if (countryComponent) {
                country = countryComponent.short_name || countryComponent.shortText;
              }
            }

            this.value = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
              address: place.formatted_address,
              city: place.name,
              state,
              country,
              placeId: place.place_id,
            };
          } else {
            this.value = {
              address: place.name,
            };
          }
        });
      });
    });
  }

  public clear() {
    this.addressValue = null;
    this.value = null;
    this.onAddressClear.emit();
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/city.selector/city.selector.component.ts